define('apps/classrooms/views/pdf-utils/generate-per-page-pdf-download',[
    "vendor/jspdf/jspdf",
    "vendor/jszip/jszip",
    "vendor/jszip-utils/jszip-utils",
    "vendor/jsfilesaver/jsfilesaver",
    "apps/classrooms/views/pdf-utils/common",
    "apps/classrooms/views/pdf-utils/pdf-mixin",
],
/*eslint strict: [0, "function"]*/
function(
    jspdf,
    JSZip,
    jsZipUtils,
    jsFilesaver,
    pdfCommonUtils,
    pdfMixin
) {
   /**
     * Takes a list of printable students and creates a PDF with one student
     *  sign in qr code and details per page OR creates a zip file containing individual student pdf on a
     *  single page. The layout option associated with print layout is: Single Student.
     */
    function buildPerPagePDF(targetStudents, isZip, zipFile, folder) {
        var qrWidth = 2,
            students = targetStudents || this.model.get('printStudents'),
            totalStudents = students.length,
            topMargin = 1,
            textMargin = .25,
            fontSize = 12,
            columnWidth = null,
            domain = this.model.get('currentDomain');

        // If the user wants to view in print preview, lets create a PDF obj
        //  in outer scope and append pages vs download which is pdf per student.
        if (!isZip) {
            var pdf = new jsPDF({ // eslint-disable-line new-cap
                "orientation": 'p',
                "unit": 'in',
                "format": 'letter',
            });

            columnWidth = pdf.internal.pageSize.getWidth() / 2;
        }

        for (var i = 0; i < totalStudents; i++) {
            // If we are downloading a zip, we need to create new PDF instance object
            //  per student.
            if (isZip) {
                var pdf = new jsPDF({ // eslint-disable-line new-cap
                    "orientation": 'p',
                    "unit": 'in',
                    "format": 'letter',
                });

                // check cached calc so we dont need to call this each time.
                if (!columnWidth) {
                    columnWidth = pdf.internal.pageSize.getWidth() / 2;
                }
            }

            pdf.setFontSize(fontSize);

            // set starting offsets and expand based on meta.
            var contentHeightOffset = topMargin,
                colOffset = columnWidth;

            // grab target student and attempt to make a reasonably
            //  consistent struct for us to work with.
            var student = students[i],
                studentNameLabel = this.getStudentLabelName(student),
                pageMeta = [
                    {
                        "text": 'Discovery Education',
                        "topMargin": textMargin,
                    },
                    {
                        "text": domain,
                        "topMargin": textMargin,
                    },
                    {
                        "image": student.qrAuth.qr_png_b64,
                        "topMargin": qrWidth + .35,
                        "width": qrWidth,
                        "height": qrWidth,
                        "alias": student.id,
                    },
                    {
                        "text": '(' + student.username + ')',
                        "topMargin": textMargin,
                    },
                    {
                        "text": student.qrAuth.localExpiryWithLabel,
                        "topMargin": textMargin,
                    },
                ];

            if (studentNameLabel) {
                pageMeta.splice(2, 0, {
                    "text": studentNameLabel,
                    "topMargin": textMargin,
                });
            }

            // fill out page obj with student content.
            for (var pm = 0; pm < pageMeta.length; pm++) {
                var meta = pageMeta[pm];

                if ('text' in meta) {
                    pdf.text(
                        meta.text,
                        colOffset,
                        contentHeightOffset,
                        'center'
                    );
                } else {
                    pdf.addImage(
                        meta.image,
                        'PNG',
                        colOffset - 1,
                        contentHeightOffset,
                        meta.width,
                        meta.height,
                        meta.alias
                    );
                }

                contentHeightOffset += meta.topMargin;
            }

            var hasMoreStudents = i < totalStudents - 1;

            // if we are doing print preview, lets just add a page. If we are downloading
            //  a zip of individual student PDFs, lets append the file to our zip obj.
            if (!isZip) {
                if (hasMoreStudents) {
                    pdf.addPage();
                }
            } else {
                var isStudent = !!this.model.get('student');

                // make sure we dont have a student or a classroom before trying to add zip
                //  and directory structure for a single student or classroom.
                if (isStudent || !!this.model.get('classroom')) {
                    isZip = false;

                    if (!isStudent && hasMoreStudents) {
                        pdf.addPage();
                    }
                } else {
                    var folderName = folder ? folder + '/' : '',
                        pdfFileName = student.first_name + ' ' + student.last_name + '.pdf';

                    var pdfFilePathAndName = folderName+ pdfFileName;

                    zipFile = this.writeFileToZip(zipFile, pdfFilePathAndName, pdf);
                }
            }
        }

        return isZip ? zipFile : pdf;
    };

    return function(isZip, model, forcePDFFormat) {
        this.model = model;
        this.buildLayout = buildPerPagePDF;

        $.each(Object.keys(pdfMixin), _.bind(function(_, key) {
            this[key] = pdfMixin[key];
        }, this))

        return this.buildTargetTypePDF(isZip, forcePDFFormat);
    };
});

